import { Routes } from '@angular/router'

import { isAuthenticatedGuard } from '../helper/auth.guard'

export const routes: Routes = [
	{
		path: '',
		loadComponent: () => import('./log-in/log-in-page/log-in-page.component').then(m => m.LogInPageComponent),
		pathMatch: 'full',
		data: {
			title: 'سامانه lmsPlus',
			tab: {
				title: 'ورود',
				requiresTab: false
			}
		}
	},

		{
			path: 'lms-plus',
			loadComponent: () => import('./coreUi-files/containers/default-layout/default-layout.component').then(m => m.DefaultLayoutComponent),
			canActivate: [isAuthenticatedGuard],
			data: {
				title: 'پنل مدیریت ',
				tab: {
					title: 'پنل مدیریت',
					requiresTab: false
				}
			},
			children: [
				{
					path: 'panel',
					loadChildren: () => import('./components/lmsPlus.routes').then(m => m.lmsPlusRoutes)
				}]
		},
	{
		path: '**',
		redirectTo: '',
		pathMatch: 'full'
	}
]
